import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function DragHandleLinesIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="2 2 12 12"
        xmlns="http://www.w3.org/2000/svg"
      >
        <rect x="2" y="5" width="12" height="2" rx="1" />
        <rect x="2" y="9" width="12" height="2" rx="1" />
      </svg>
    </Icon>
  );
}
